// Mock reviews data
export const mockReviews = [
  {
    id: "rev-1",
    external_id: "WB_5STARS_001",
    source: "wildberries_cab1",
    type: "review",
    product_sku: "40955",
    product_name: "Тушь для ресниц Volume",
    brand: "Art-Visage",
    rating: 5,
    text: null,
    advantages: "Отличная тушь, очень довольна! Ресницы длинные и пышные.",
    disadvantages: null,
    has_text: false,
    has_advantages: true,
    has_disadvantages: false,
    has_question_mark: false,
    status: "ready",
    has_stop_words: false,
    priority: "normal",
    sentiment: "positive",
    topics: ["качество_товара", "благодарность"],
    competitor_mention: false,
    profanity_score: 0,
    assigned_strategy_id: "strat-5",
    response_status: "published",
    generated_response_text: "Добрый день!\n\nБлагодарим Вас за оставленный отзыв, мы тронуты Вашим вниманием. Рады, что наша тушь Volume вам понравилась! Ваши слова вдохновляют нашу команду создавать ещё более качественную продукцию.\n\nЖелаем Вам только приятных эмоций от покупок!\n\nС любовью, Art-Visage!",
    marketplace_created_at: "2025-10-25T10:30:00Z",
    created_at: "2025-10-25T10:35:00Z",
    updated_at: "2025-10-25T10:35:00Z",
  },
  {
    id: "rev-2",
    external_id: "WB_NEG_QUESTION_001",
    source: "wildberries_cab1",
    type: "review",
    product_sku: "40955",
    product_name: "Тушь для ресниц Volume",
    brand: "Art-Visage",
    rating: 1,
    text: "Тушь ужасная, быстро засохла. Как вернуть деньги?",
    advantages: null,
    disadvantages: "Быстро засохла, деньги на ветер",
    has_text: true,
    has_advantages: false,
    has_disadvantages: true,
    has_question_mark: true,
    status: "ready",
    has_stop_words: false,
    priority: "high",
    sentiment: "negative",
    topics: ["качество_товара", "проблема_использования", "возврат"],
    competitor_mention: false,
    profanity_score: 0,
    assigned_strategy_id: "strat-2",
    response_status: "approved",
    generated_response_text: "Добрый день!\n\nМы ценим каждого покупателя и благодарим вас за обратную связь. Нам жаль, что тушь не оправдала ваших ожиданий. Проблемы с быстрым высыханием могут возникать из-за неплотного закрытия крышечки.\n\nЧто касается возврата - вы можете оформить возврат товара в течение 21 дня через личный кабинет маркетплейса.\n\nНадеемся увидеть Вас снова среди наших покупателей.\n\nС наилучшими пожеланиями, компания Art-Visage!",
    marketplace_created_at: "2025-10-26T14:20:00Z",
    created_at: "2025-10-26T14:25:00Z",
    updated_at: "2025-10-26T14:25:00Z",
  },
  {
    id: "rev-3",
    external_id: "OZON_STOP_WORDS_001",
    source: "ozon",
    type: "review",
    product_sku: "52422",
    product_name: "Тональный крем",
    brand: "Estrade",
    rating: 1,
    text: "Обман! Аллергия началась сразу! Требую компенсацию!",
    advantages: null,
    disadvantages: null,
    has_text: true,
    has_advantages: false,
    has_disadvantages: false,
    has_question_mark: false,
    status: "manual_review",
    has_stop_words: true,
    priority: "critical",
    sentiment: "negative",
    topics: ["аллергия", "жалоба"],
    competitor_mention: false,
    profanity_score: 0.2,
    assigned_strategy_id: "strat-1",
    response_status: null,
    marketplace_created_at: "2025-10-27T09:15:00Z",
    created_at: "2025-10-27T09:20:00Z",
    updated_at: "2025-10-27T09:20:00Z",
  },
  {
    id: "rev-4",
    external_id: "WB_QUESTION_001",
    source: "wildberries_cab1",
    type: "question",
    product_sku: "52422",
    product_name: "Тональный крем",
    brand: "Estrade",
    rating: null,
    text: "Здравствуйте! Скажите пожалуйста, какой тон подойдёт для светлой кожи?",
    advantages: null,
    disadvantages: null,
    has_text: true,
    has_advantages: false,
    has_disadvantages: false,
    has_question_mark: true,
    status: "ready",
    has_stop_words: false,
    priority: "normal",
    sentiment: "neutral",
    topics: ["вопрос_по_продукту", "выбор_тона"],
    competitor_mention: false,
    profanity_score: 0,
    assigned_strategy_id: "strat-4",
    response_status: "draft",
    generated_response_text: "Добрый день!\n\nОбратите внимание на тон 201 (слоновая кость) - он идеально подойдёт для светлой кожи. Также можете рассмотреть тон 202 (натуральный бежевый) для более теплого оттенка.\n\nЕсли у вас остались вопросы, мы всегда рады помочь!\n\nС уважением, Estrade.",
    marketplace_created_at: "2025-10-28T11:40:00Z",
    created_at: "2025-10-28T11:45:00Z",
    updated_at: "2025-10-28T11:45:00Z",
  },
  {
    id: "rev-5",
    external_id: "WB_4STARS_001",
    source: "wildberries_cab1",
    type: "review",
    product_sku: "56789",
    product_name: "Помада матовая",
    brand: "Art-Visage",
    rating: 4,
    text: "Хорошая помада, цвет красивый. Немного сушит губы, но в целом довольна.",
    advantages: "Красивый цвет, стойкая",
    disadvantages: "Немного сушит губы",
    has_text: true,
    has_advantages: true,
    has_disadvantages: true,
    has_question_mark: false,
    status: "ready",
    has_stop_words: false,
    priority: "normal",
    sentiment: "positive",
    topics: ["качество_товара", "цвет", "текстура"],
    competitor_mention: false,
    profanity_score: 0,
    assigned_strategy_id: "strat-6",
    response_status: "published",
    generated_response_text: "Добрый день!\n\nСпасибо за ваш отзыв о помаде матовой. Рады, что вам понравился цвет и стойкость! Что касается сухости губ - рекомендуем использовать увлажняющий бальзам перед нанесением матовой помады для комфортного ношения.\n\nБудем рады видеть вас снова!\n\nС уважением, Art-Visage!",
    marketplace_created_at: "2025-10-29T16:30:00Z",
    created_at: "2025-10-29T16:35:00Z",
    updated_at: "2025-10-29T16:35:00Z",
  },
  {
    id: "rev-6",
    external_id: "WB_5STARS_NO_TEXT_001",
    source: "wildberries_cab2",
    type: "review",
    product_sku: "40955",
    product_name: "Тушь для ресниц Volume",
    brand: "Art-Visage",
    rating: 5,
    text: null,
    advantages: null,
    disadvantages: null,
    has_text: false,
    has_advantages: false,
    has_disadvantages: false,
    has_question_mark: false,
    status: "ready",
    has_stop_words: false,
    priority: "normal",
    sentiment: "positive",
    topics: [],
    competitor_mention: false,
    profanity_score: 0,
    assigned_strategy_id: "strat-5",
    response_status: "published",
    generated_response_text: "Добрый день!\n\nСпасибо за вашу оценку! ⭐️⭐️⭐️⭐️⭐️\n\nМы рады, что вам понравилась наша продукция!\n\nС любовью, Art-Visage!",
    marketplace_created_at: "2025-10-30T08:15:00Z",
    created_at: "2025-10-30T08:20:00Z",
    updated_at: "2025-10-30T08:20:00Z",
  },
  {
    id: "rev-7",
    external_id: "OZON_3STARS_001",
    source: "ozon",
    type: "review",
    product_sku: "67890",
    product_name: "Блеск для губ",
    brand: "Estrade",
    rating: 3,
    text: "Обычный блеск, ничего особенного. Ожидала большего за эту цену.",
    advantages: null,
    disadvantages: "Цена завышена",
    has_text: true,
    has_advantages: false,
    has_disadvantages: true,
    has_question_mark: false,
    status: "ready",
    has_stop_words: false,
    priority: "normal",
    sentiment: "neutral",
    topics: ["качество_товара", "цена"],
    competitor_mention: false,
    profanity_score: 0,
    assigned_strategy_id: "strat-7",
    response_status: "draft",
    generated_response_text: "Добрый день!\n\nБлагодарим за ваш отзыв о блеске для губ. Мы ценим вашу обратную связь и постоянно работаем над улучшением качества наших продуктов с учетом пожеланий покупателей.\n\nБудем рады видеть вас снова!\n\nС уважением, Estrade!",
    marketplace_created_at: "2025-10-30T12:50:00Z",
    created_at: "2025-10-30T12:55:00Z",
    updated_at: "2025-10-30T12:55:00Z",
  },
  {
    id: "rev-8",
    external_id: "WB_COMPETITOR_001",
    source: "wildberries_cab1",
    type: "review",
    product_sku: "56789",
    product_name: "Помада матовая",
    brand: "Art-Visage",
    rating: 2,
    text: "Не понравилось. У Maybelline помады намного лучше и дешевле.",
    advantages: null,
    disadvantages: "Качество хуже чем у конкурентов",
    has_text: true,
    has_advantages: false,
    has_disadvantages: true,
    has_question_mark: false,
    status: "manual_review",
    has_stop_words: false,
    priority: "high",
    sentiment: "negative",
    topics: ["сравнение", "качество_товара", "цена"],
    competitor_mention: true,
    profanity_score: 0,
    assigned_strategy_id: "strat-3",
    response_status: null,
    marketplace_created_at: "2025-10-31T10:10:00Z",
    created_at: "2025-10-31T10:15:00Z",
    updated_at: "2025-10-31T10:15:00Z",
  },
];
